import { hasBoneAt } from "./index20.js";
import { BoneSide, RG_TYPE } from "@project-rouge/rg-core";
import { Line3, Vector3 } from "three";
var tol = .1;
var mLineA = new Line3();
var mLineB = new Line3();
var dir = new Vector3();
var point = new Vector3();
function getCapturedDistances(muscleA) {
	const { size, dists: closingDists } = getSelfClosingDists({
		muscle: muscleA,
		line: mLineA,
		checkGrid: true
	});
	const muscleB = muscleA.bone.muscles.find((m) => m !== muscleA);
	if (muscleB) {
		const { dists: closingDistsB } = getSelfClosingDists({
			muscle: muscleB,
			line: mLineB
		});
		if (closingDistsB.some((d) => d)) {
			mLineB.delta(dir).normalize();
			if (closingDistsB[1]) {
				point.copy(mLineB.end).addScaledVector(dir, -closingDistsB[1]);
				const alpha = mLineA.closestPointToPointParameter(point);
				if (alpha > 0) closingDists[0] = size * alpha;
			}
			if (closingDistsB[0]) {
				point.copy(mLineB.start).addScaledVector(dir, closingDistsB[0]);
				const alpha = mLineA.closestPointToPointParameter(point);
				if (alpha < 1) closingDists[1] = size - size * alpha;
			}
		}
	}
	return closingDists;
}
function getSelfClosingDists({ muscle, line, checkGrid }) {
	toLine(muscle, line);
	const size = line.distance();
	const dists = [0, 0];
	for (const obj of muscle.gFUnits) {
		if (obj.type !== RG_TYPE.Apartment || !obj.data.closeLength) continue;
		if (obj.data.closeDirection[0] > 0) dists[0] = obj.data.closeLength;
		else dists[1] = obj.data.closeLength;
	}
	if (dists.some((d) => d)) {
		const shortedDists = getMuscleShortedDists(muscle, size);
		dists[0] += shortedDists[0];
		dists[1] += shortedDists[1];
	}
	if (checkGrid) {
		const dists2 = getGridClosingDistances(muscle, line);
		if (dists2[0]) dists[0] = dists2[0];
		if (dists2[1]) dists[1] = dists2[1];
	}
	return {
		dists,
		size
	};
}
function getMuscleShortedDists(muscle, size) {
	const dists = [0, 0];
	if (!muscle.realLength) return dists;
	const diff = size - muscle.realLength;
	const unlockedSide = muscle.lockEnds.indexOf(false);
	dists[unlockedSide] = diff;
	return dists;
}
function getGridClosingDistances(muscle, mLine) {
	const dists = [0, 0];
	const isLeft = muscle.side === BoneSide.Left;
	if (!hasBoneAt({
		bone: muscle.bone,
		right: isLeft,
		start: isLeft,
		outerLoad: true
	})) return dists;
	const jointI = isLeft ? 0 : 1;
	const sharedJoint = muscle.bone.joints[jointI];
	const boneB = sharedJoint.bones.find((b) => b !== muscle.bone);
	const muscleSideB = boneB.joints.indexOf(sharedJoint) ? BoneSide.Left : BoneSide.Right;
	toLine(boneB.muscles.find((m) => m.side === muscleSideB), mLineB);
	const bPoint = mLine.start.distanceToSquared(mLineB.start) < mLine.start.distanceToSquared(mLineB.end) ? mLineB.start : mLineB.end;
	const closest = mLine.closestPointToPoint(bPoint, true, point);
	if (bPoint.distanceToSquared(closest) < tol * tol) {
		const muscleIndexA = mLine.start.distanceToSquared(closest) < mLine.end.distanceToSquared(closest) ? 0 : 1;
		dists[muscleIndexA] = point.distanceTo(!muscleIndexA ? mLine.start : mLine.end);
	}
	return dists;
}
function toLine(obj, out) {
	out.start.fromArray(obj.points[0]);
	out.end.fromArray(obj.points[1]);
	return out;
}
export { getCapturedDistances };

//# sourceMappingURL=index127.js.map